import { isElement, isNil } from "lodash";
import $ from "jquery";
import mustache from 'mustache';

import Request from "../../03-api/request";
import Dropdown from "../../04-components/dropdown";
import {
    subscribe,
    unsubscribe
} from "../../01-helpers/event-manager";
import {
    DROPDOWN_CLICKED,
    LOGIN_WIDGET_RESPONSE_SUCCESS,
    LOGIN_WIDGET_RESPONSE_ERROR
} from "../../02-const/event-names";

const
    elements = {
        base: Symbol('baseElement'),
        dropdowns: Symbol('dropdowns')
    }


/**
 * bind events
 */
function bindEvents() {
    subscribe(DROPDOWN_CLICKED, dropdownClicked.bind(this));
}

/**
 * callback when dorpdown is clicked.
 */
function dropdownClicked(evt) {
    const dropdown = this[elements.baseDropdown];
    if(evt.detail.dropdownId === dropdown.id) {
        dropdown.toggle();
    } else {
        dropdown.close();
    }
}

function getError(status) {
    this._warn(`Error receiving data from endpoint ${status}`);
}

function injectHtml(element, html) {
    const parsed = mustache.render($(html).html());

    $(element).append(parsed);
}

function getSuccess(response) {
    injectHtml(this[elements.base], response?.detail?.response);
    this[elements.base].classList.add('js-dropdown');
    this[elements.base].classList.add('c-login');

    this[elements.dropdown] = new Dropdown(this[elements.base]);
    bindEvents.call(this);

}

/**
 * Login module
 */
export default class Login {
    /**
     * @memberof Login
     */
    constructor(baseElement) {

        if (!isElement(baseElement)) {
            return;
        }

        // Store the base element for this instance.
        this[elements.base] = baseElement;

        if (isNil(this[elements.base].attributes["data-url"])) {

            this[elements.dropdown] = new Dropdown(this[elements.base]);
            bindEvents.call(this);
            return;
        }

        this._checkRequirements();

        const request = new Request(this);
        subscribe(LOGIN_WIDGET_RESPONSE_SUCCESS, getSuccess.bind(this));
        subscribe(LOGIN_WIDGET_RESPONSE_ERROR, getError.bind(this));

        request.get(`${this[elements.base].attributes["data-url"].value}?returnUrl=${encodeURI(document.location.href)}`, LOGIN_WIDGET_RESPONSE_SUCCESS, LOGIN_WIDGET_RESPONSE_ERROR);
    }

    _checkRequirements() {
        if (!isElement(this[elements.base])) {
            throw `Unable to find ${elements.base} in Login, no element has been provided`;
        }

        if (isNil(this[elements.base].attributes["data-url"])) {
            throw "No url endpoint specified";
        }
    }

    _warn(message) {
        console.warn(message);
    }



    close() {
        this[elements.baseDropdown].close();
    }

    destroy() {
        unsubscribe(DROPDOWN_CLICKED, dropdownClicked.bind(this));

        unsubscribe(LOGIN_WIDGET_RESPONSE_SUCCESS, getSuccess.bind(this));
        unsubscribe(LOGIN_WIDGET_RESPONSE_ERROR, getError.bind(this));

        if (this[elements.dropdown]) {
            this[elements.dropdown].destroy();
        }
    }
}
